import { useEffect } from 'react';

type P = {
  eventId: string;
  redirectToEventDetail: (id: string) => Promise<void>;
};

const RedirectToEventDetail = ({ eventId, redirectToEventDetail }: P) => {
  useEffect(() => {
    void redirectToEventDetail(eventId);
  }, [eventId, redirectToEventDetail]);

  return null;
};

export default RedirectToEventDetail;
